import React, { useState, useEffect } from "react";
import { X, Plus, Save } from "lucide-react";
import { useApp } from "../context/AppContext";
import { CATEGORIES } from "../data/mockData";

export default function TransactionModal({ transaction, onClose }) {
  const { dispatch } = useApp();
  const isEdit = !!transaction;
  const [form, setForm] = useState({
    description: "", amount: "", category: CATEGORIES[0],
    type: "expense", date: new Date().toISOString().split("T")[0],
  });

  useEffect(() => {
    if (isEdit) setForm({ ...transaction, amount: String(transaction.amount) });
  }, [transaction]);

  const handleSubmit = () => {
    if (!form.description || !form.amount || !form.date) return;
    const payload = { ...form, amount: parseFloat(form.amount), id: isEdit ? transaction.id : Date.now() };
    dispatch({ type: isEdit ? "EDIT_TRANSACTION" : "ADD_TRANSACTION", payload });
    onClose();
  };

  const inputCls = "w-full bg-bg-primary border border-border rounded-xl px-3 py-2.5 text-sm font-body text-white placeholder-white/20 focus:outline-none focus:border-accent-cyan/50 transition-colors";

  return (
    <div className="fixed inset-0 bg-black/70 backdrop-blur-sm z-50 flex items-center justify-center p-4 animate-fade-in">
      <div className="bg-bg-card border border-border rounded-2xl w-full max-w-md p-6 animate-slide-up shadow-2xl">
        <div className="flex items-center justify-between mb-6">
          <h2 className="font-display font-semibold text-white text-lg">
            {isEdit ? "Edit Transaction" : "Add Transaction"}
          </h2>
          <button onClick={onClose} className="w-8 h-8 rounded-lg bg-bg-hover flex items-center justify-center text-white/40 hover:text-white transition-colors">
            <X size={16} />
          </button>
        </div>

        <div className="space-y-4">
          <div>
            <label className="text-xs text-white/40 font-body uppercase tracking-wider mb-1.5 block">Description</label>
            <input className={inputCls} placeholder="e.g. Grocery Store" value={form.description}
              onChange={(e) => setForm({ ...form, description: e.target.value })} />
          </div>

          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="text-xs text-white/40 font-body uppercase tracking-wider mb-1.5 block">Amount ($)</label>
              <input className={inputCls} type="number" placeholder="0.00" value={form.amount}
                onChange={(e) => setForm({ ...form, amount: e.target.value })} />
            </div>
            <div>
              <label className="text-xs text-white/40 font-body uppercase tracking-wider mb-1.5 block">Date</label>
              <input className={inputCls} type="date" value={form.date}
                onChange={(e) => setForm({ ...form, date: e.target.value })} />
            </div>
          </div>

          <div>
            <label className="text-xs text-white/40 font-body uppercase tracking-wider mb-1.5 block">Type</label>
            <div className="grid grid-cols-2 gap-2">
              {["income", "expense"].map((t) => (
                <button key={t} onClick={() => setForm({ ...form, type: t })}
                  className={`py-2.5 rounded-xl text-sm font-body font-medium capitalize transition-all duration-200
                    ${form.type === t
                      ? t === "income" ? "bg-accent-green/20 text-accent-green border border-accent-green/30"
                        : "bg-accent-red/20 text-accent-red border border-accent-red/30"
                      : "bg-bg-primary border border-border text-white/40 hover:text-white/70"
                    }`}>
                  {t}
                </button>
              ))}
            </div>
          </div>

          <div>
            <label className="text-xs text-white/40 font-body uppercase tracking-wider mb-1.5 block">Category</label>
            <select className={inputCls} value={form.category}
              onChange={(e) => setForm({ ...form, category: e.target.value })}>
              {CATEGORIES.map((c) => <option key={c} value={c}>{c}</option>)}
            </select>
          </div>
        </div>

        <div className="flex gap-3 mt-6">
          <button onClick={onClose} className="flex-1 py-2.5 rounded-xl border border-border text-white/40 hover:text-white font-body text-sm transition-colors">
            Cancel
          </button>
          <button onClick={handleSubmit}
            className="flex-1 py-2.5 rounded-xl bg-accent-cyan text-bg-primary font-body font-medium text-sm flex items-center justify-center gap-2 hover:bg-accent-cyan/90 transition-colors shadow-lg shadow-accent-cyan/20">
            {isEdit ? <><Save size={15} /> Save</> : <><Plus size={15} /> Add</>}
          </button>
        </div>
      </div>
    </div>
  );
}
